import Container from '@mui/material/Container';
import type { ReactNode } from 'react';

interface PageContainerProps {
    children: ReactNode;
}

const PageContainer = ({ children }: PageContainerProps) => {
    return (
        <Container
            maxWidth="lg"
            sx={{
                '& > *': {
                    position: 'relative',
                },
                mt: 4,
            }}
        >
            {children}
        </Container>
    );
};

export default PageContainer;
